import React from 'react';
import { observer } from 'mobx-react';
import './Tabs.scss';

// const waterwayTabs = [
//   { tab: 'combined-view', title: 'Combined View' },
//   { tab: 'station-view', title: 'Station View' },
//   { tab: 'reach-view', title: 'Reach View' },
// ];

interface ITabsProps {
  tabs: any;
  currentTab: string;
  onClick: any;
}

export const Tabs = observer(({ tabs, currentTab, onClick }: ITabsProps) => (
  <div className="tablist" role="tablist">
    {tabs.map((tab) => (
      <Tab key={tab.tab} tab={tab} currentTab={currentTab} onClick={onClick} />
    ))}
  </div>
));

interface ITabProps {
  tab: any;
  currentTab: string;
  onClick: any;
}

export const Tab = observer(({ tab, currentTab, onClick }: ITabProps) => (
  <button data-testid={`tab-${tab.tab}`} className={`${currentTab === tab.tab ? 'active' : ''}`} onClick={() => onClick(tab.tab)} role="tab">
    {tab.title}
  </button>
));
